import { render, staticRenderFns } from "./ValuationJourney.vue?vue&type=template&id=4075169b&"
import script from "./ValuationJourney.vue?vue&type=script&lang=js&"
export * from "./ValuationJourney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports